import PropTypes from "prop-types";
import React from "react";
import Form from "react-bootstrap/Form";

function FormInputLabel(props) {
  const { formLabel, className, required } = props;
  return (
    <Form.Label className={`mb-4 ${className}`}>
      {formLabel} {required && <em className="text-danger">*</em>}
    </Form.Label>
  );
}

export const defaultProps = {
  variant: "",
  type: "",
  className: "",
  placeholder: "",
  label: "",
  text: "",
  formLabel: "",
};

export const propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  text: PropTypes.string,
  formLabel: PropTypes.string,
  ariaLabel: PropTypes.string,
  ariaDescribedby: PropTypes.string,
  disabled: PropTypes.bool,
  formik: PropTypes.object,
};

FormInputLabel.defaultProps = defaultProps;

FormInputLabel.propTypes = propTypes;
export default FormInputLabel;
